import React from 'react'
import KeyVariant from 'mdi-material-ui/KeyVariant'

export default function Permission(props) {
  return <KeyVariant {...props} />
}
